'use client';

import { useEffect } from 'react';
import { ICON_FONT_STYLESHEET_HREFS } from '@/lib/fonts/googleFonts';

/**
 * Injects the Material icon stylesheets on the client after hydration.
 *
 * These fonts are decorative and must not block first paint. Rendering them in
 * SSR markup and flipping `media` with an inline script caused a hydration
 * mismatch (server `media="print"` vs client `media="all"`). Appending the
 * <link>s client-side keeps them non-render-blocking without any SSR markup to
 * mismatch against.
 */
export function AsyncIconFontLinks(): null {
    useEffect(() => {
        const appended: HTMLLinkElement[] = [];

        for (const href of ICON_FONT_STYLESHEET_HREFS) {
            if (document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
                continue;
            }

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            document.head.appendChild(link);
            appended.push(link);
        }

        return () => {
            for (const link of appended) {
                link.remove();
            }
        };
    }, []);

    return null;
}
